import React, { createContext, useContext, useEffect, useState } from "react";

const TRANSLATIONS = {
  en: {
    app_name: "Ronil Command Center",
    dashboard: "Dashboard",
    service_cases: "Service Cases",
    tasks: "Tasks",
    parts_requests: "Parts Requests (PEC)",
    customer_feedback: "Customer Feedback",
    classification_requests: "Classification Requests (PCP)",
    warranty_claims: "Warranty Claims",
    maintenance_plans: "Maintenance Plans",
    reports: "Reports",
    admin_settings: "Admin Settings",
    coming_next: "Coming next",
    login: "Sign in",
    email: "Email",
    password: "Password",
    logout: "Sign out",
    search_placeholder: "Search customer / VIN / plate / OB / SC...",
    notifications: "Notifications",
    mark_all_read: "Mark all as read",
    no_notifications: "No notifications",
    exception_dashboard: "Exception Dashboard",
    exception_subtitle: "Operational exceptions requiring attention",
    open_cases: "Open cases",
    open_prs: "Open parts requests",
    open_tasks: "Open tasks",
    case_number: "Case",
    customer: "Customer",
    vehicle: "Vehicle",
    branch: "Branch",
    status: "Status",
    priority: "Priority",
    responsible: "Responsible",
    deadline: "Deadline",
    next_action: "Next action",
    last_contact: "Last contact",
    feedback: "Feedback",
    overview: "Overview",
    contacts: "Customer Contacts",
    attachments: "Attachments",
    audit_log: "Audit Log",
    comments: "Comments",
    warranties: "Warranties",
    add_contact: "Log contact",
    contact_method: "Method",
    contact_result: "Result",
    summary: "Summary",
    next_followup: "Next follow-up",
    change_status: "Change status",
    comment_required: "Comment required",
    save: "Save",
    cancel: "Cancel",
    create: "Create",
    new_case: "New case",
    new_task: "New task",
    new_parts_request: "New parts request",
    filters: "Filters",
    all: "All",
    days: "days",
    hours: "hours",
    ago: "ago",
    open: "Open",
    in_progress: "Em curso",
    overdue: "Overdue",
    completed: "Completed",
    cancelled: "Cancelled",
    title: "Title",
    description: "Description",
    deadline_field: "Deadline",
    department: "Department",
    add_part_line: "Add part line",
    part_number: "Part number",
    quantity: "Quantity",
    eta: "ETA",
    line_status: "Line status",
    source: "Source",
    complete_task: "Complete task",
    completion_notes: "Completion notes",
    reopen: "Reopen",
    reopen_reason: "Reopen reason",
    sign_in_subtitle: "Operations control tower for Ronil LDA aftersales.",
    invalid_credentials: "Invalid email or password",
    upload: "Upload",
    download: "Download",
    no_records: "No records found",
    delivery_confirmed: "Vehicle delivered confirmed",
    customer_informed: "Customer informed",
    cancel_reason: "Cancellation reason",
    six_question_rule: "Six-question rule",
    blocking: "What is blocking progress?",
    actions: "Actions",
    register_contact: "Register contact",
    pick_user: "Select user",
    fields_required: "All required fields must be filled",
    vehicle_in_workshop_question: "Where is the vehicle?",
    vehicle_at_workshop: "In workshop",
    vehicle_with_customer: "With customer",
    open_cases_only: "Open cases only",
    overdue_only: "Overdue only",
    export_csv: "Export CSV",
    no_data: "No data",
    audit_history: "Audit history",
    feedback_indicator: "Feedback indicator",
    contact_recorded: "Contact recorded",
    parts_lines: "Parts lines",
    alidata_co: "Alidata customer order",
    alidata_job_card: "Alidata job card",
    placeholder_classification: "This module will replace the PCP workflow. It will control the process from technical diagnosis to Alidata quotation creation. Database structure is already provisioned. Full UI rolls out in v2.",
    placeholder_warranty: "This module will replace the SWC workflow. It will manage warranty claims from internal validation through brand submission, response, repair authorisation, invoicing and closure. Database structure and evidence checklists are already provisioned. Full UI rolls out in v2.",
    placeholder_maintenance: "This module will replace the MPM workflow. It will control prepaid maintenance rights sold with each vehicle. Database structure and blocking rules are already provisioned. Full UI rolls out in v2.",
  },
  pt: {
    app_name: "Ronil Command Center",
    dashboard: "Painel",
    service_cases: "Casos de Serviço",
    tasks: "Tarefas",
    parts_requests: "Pedidos de Peças (PEC)",
    customer_feedback: "Feedback do Cliente",
    classification_requests: "Pedidos de Classificação (PCP)",
    warranty_claims: "Garantias",
    maintenance_plans: "Planos de Manutenção",
    reports: "Relatórios",
    admin_settings: "Administração",
    coming_next: "Em breve",
    login: "Entrar",
    email: "Email",
    password: "Palavra-passe",
    logout: "Sair",
    search_placeholder: "Pesquisar cliente / VIN / matrícula / OB / SC...",
    notifications: "Notificações",
    mark_all_read: "Marcar todas como lidas",
    no_notifications: "Sem notificações",
    exception_dashboard: "Painel de Excepções",
    exception_subtitle: "Excepções operacionais que precisam de atenção",
    open_cases: "Casos abertos",
    open_prs: "Pedidos de peças abertos",
    open_tasks: "Tarefas abertas",
    case_number: "Caso",
    customer: "Cliente",
    vehicle: "Viatura",
    branch: "Filial",
    status: "Estado",
    priority: "Prioridade",
    responsible: "Responsável",
    deadline: "Prazo",
    next_action: "Próxima acção",
    last_contact: "Último contacto",
    feedback: "Feedback",
    overview: "Resumo",
    contacts: "Contactos com cliente",
    attachments: "Anexos",
    audit_log: "Registo de auditoria",
    comments: "Comentários",
    warranties: "Garantias",
    add_contact: "Registar contacto",
    contact_method: "Método",
    contact_result: "Resultado",
    summary: "Resumo",
    next_followup: "Próximo follow-up",
    change_status: "Mudar estado",
    comment_required: "Comentário obrigatório",
    save: "Guardar",
    cancel: "Cancelar",
    create: "Criar",
    new_case: "Novo caso",
    new_task: "Nova tarefa",
    new_parts_request: "Novo pedido de peças",
    filters: "Filtros",
    all: "Todos",
    days: "dias",
    hours: "horas",
    ago: "atrás",
    open: "Aberta",
    in_progress: "Em curso",
    overdue: "Atrasada",
    completed: "Concluída",
    cancelled: "Cancelada",
    title: "Título",
    description: "Descrição",
    deadline_field: "Prazo",
    department: "Departamento",
    add_part_line: "Adicionar linha",
    part_number: "Nº peça",
    quantity: "Quantidade",
    eta: "ETA",
    line_status: "Estado da linha",
    source: "Origem",
    complete_task: "Concluir tarefa",
    completion_notes: "Notas de conclusão",
    reopen: "Reabrir",
    reopen_reason: "Razão de reabertura",
    sign_in_subtitle: "Torre de controlo operacional do aftersales Ronil LDA.",
    invalid_credentials: "Email ou palavra-passe inválidos",
    upload: "Carregar",
    download: "Descarregar",
    no_records: "Sem registos",
    delivery_confirmed: "Entrega da viatura confirmada",
    customer_informed: "Cliente informado",
    cancel_reason: "Razão do cancelamento",
    six_question_rule: "Regra das seis perguntas",
    blocking: "O que está a bloquear o progresso?",
    actions: "Acções",
    register_contact: "Registar contacto",
    pick_user: "Escolher utilizador",
    fields_required: "Todos os campos obrigatórios devem ser preenchidos",
    vehicle_in_workshop_question: "Onde está a viatura?",
    vehicle_at_workshop: "Na oficina",
    vehicle_with_customer: "Com o cliente",
    open_cases_only: "Apenas casos abertos",
    overdue_only: "Apenas atrasados",
    export_csv: "Exportar CSV",
    no_data: "Sem dados",
    audit_history: "Histórico de auditoria",
    feedback_indicator: "Indicador de feedback",
    contact_recorded: "Contacto registado",
    parts_lines: "Linhas de peças",
    alidata_co: "Pedido de cliente Alidata",
    alidata_job_card: "Folha de obra Alidata",
    placeholder_classification: "Este módulo substituirá o fluxo PCP. Vai controlar o processo desde o diagnóstico técnico até à criação da cotação no Alidata. A estrutura da base de dados já está preparada. O UI completo será lançado na v2.",
    placeholder_warranty: "Este módulo substituirá o fluxo SWC. Vai gerir reclamações de garantia desde a validação interna até à submissão à marca, resposta, autorização de reparação, facturação e encerramento. A estrutura da base de dados e os checklists de evidência já estão preparados. O UI completo será lançado na v2.",
    placeholder_maintenance: "Este módulo substituirá o fluxo MPM. Vai controlar os direitos de manutenção pré-paga vendidos com cada viatura. A estrutura da base de dados e as regras de bloqueio já estão preparadas. O UI completo será lançado na v2.",
  },
};

const I18nContext = createContext({ t: (k) => k, lang: "pt", setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("rcc_lang") || "pt");
  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("rcc_lang", l);
  };
  const t = (key) => TRANSLATIONS[lang]?.[key] ?? TRANSLATIONS.en[key] ?? key;
  return <I18nContext.Provider value={{ t, lang, setLang }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
